export const GALLERY_TAB_TYPE = {
    MEDIA: 'media',
    FAVOURITE: 'favourite', 
    ALL_MEDIA: 'all_media',
    PURCHASED: 'purchased',
    UNPURCHASED: 'unpurchased'
}

// i18n keys, not translated strings: translate at render time ($t) so labels follow locale changes
export const GALLERY_TAB_TYPE_LABELS = {
    [GALLERY_TAB_TYPE.MEDIA]: 'gallery.tabs.media',
    [GALLERY_TAB_TYPE.FAVOURITE]: 'gallery.tabs.favourite',
    [GALLERY_TAB_TYPE.ALL_MEDIA]: 'gallery.tabs.all_media',
    [GALLERY_TAB_TYPE.PURCHASED]: 'gallery.tabs.purchased',
    [GALLERY_TAB_TYPE.UNPURCHASED]: 'gallery.tabs.unpurchased'
}
